import Element from '../../../core/Element';
import type { Theme } from '../../../core/types';
import styles from './index.module.less';
import classnames from 'classnames';

interface Props {
  active?: boolean;
  $size?: 'small' | 'medium' | 'large';
  $fullscreen?: boolean;
  theme?: Theme;
  ariaLabel?: string;
}

export const Spinner = ({
  ariaLabel,
  theme,
  active = false,
  $fullscreen = false,
  $size = 'medium',
}: Props) => {
  if (!active) {
    return null;
  }

  return (
    <Element
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={ariaLabel}
      role="progressbar"
      theme={{ ...theme }}
      className={classnames({ [styles.fullScreen]: $fullscreen })}
    >
      <Element className={`${styles[$size]} ${styles.progressIndeterminate}`} />
    </Element>
  );
};
